const setLocalStorageTimestamp = ({ key }) => {
  const currentTime = (/* @__PURE__ */ new Date()).getTime();
  localStorage.setItem(key, currentTime.toString());
};
export {
  setLocalStorageTimestamp
};
//# sourceMappingURL=setLocalStorageTimestamp.js.map
